import React from 'react'
import axios from 'axios'
import globalConfig from '../../utils/globalConfig'
import globalStyles from '../../utils/globalStyles'
import SearchIcon from '@mui/icons-material/Search';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import SettingsIcon from '@mui/icons-material/Settings';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import FileUploadIcon from '@mui/icons-material/FileUpload';

import {
  List, Box, Typography, Input, Select, MenuItem, Button, Divider, Menu, FormControl, FormGroup, Checkbox, Radio, FormControlLabel, RadioGroup,
  TableContainer, Table, TableRow, TableHead, TableBody, Paper, Pagination
} from '@mui/material'
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell'
import legolasApi from '../../api/legolas'

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: '#2b3f7a',
    color: theme.palette.common.white,
    padding: globalStyles.common.infoTablesPadding,
    borderRight: '2px solid #fff',
    whiteSpace: 'nowrap',
    borderRadius: '0px !important'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    padding: globalStyles.common.infoTablesPadding,
    borderRadius: '0px !important'
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));



function ShipmentStatusList() {
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [columnsOpen, setColumnsOpen] = React.useState(false)
  const [anchorCol, setAnchorCol] = React.useState(null)
  const [listData, setListData] = React.useState([])
  const [totalCount, setTotalcount] = React.useState(0)
  const [selectedCheck ,setSeletedCheck] =React.useState([]);
  const [selectedStatus ,setSeletedStatus] =React.useState([]);
  const [value,setValue]= React.useState([]);
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    { id: 'id', label: '' }, { id: 'order_id', label: 'Order Number' }, { id: 'created_at', label: 'Purchase Date' }, { id: 'lookup_shipping_status', label: 'Shipment Status' },
    { id: 'billing_customer_name', label: 'Customer Name' }, { id: 'shipping_method', label: 'Shipping Method' },
    { id: 'payment_method', label: 'Payment Method' }, { id: 'order_status', label: 'Order Status' }
  ])
  const [currentPage, setCurrentPage] = React.useState(1)
  
  const allTableHeaders = [
    { id: 'id', label: 'ID' }, { id: 'order_number', label: 'Order Number' }, { id: 'ship_status', label: 'Shipment Status' },
    { id: 'cust_name', label: 'Customer Name' }, { id: 'shipping_method', label: 'Shipping Method' },
    { id: 'order_status', label: 'Order Status' }
  ]

  const open = Boolean(anchorEl)
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleColumnClick = (e) => {
    setColumnsOpen(true)
    setAnchorCol(e.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
   
    console.log("select check now",selectedCheck);
      
   
  }, [selectedCheck])
  

  function findChecked(headerId, headerArr) {
    let checked = false
    // console.log('headerId :', headerId)
    // console.log('headerArr: ', headerArr)
    for (let i = 0; i < headerArr.length; i++) {
      const checkElem = headerArr[i]
      if (checkElem['id'] == headerId) {
        checked = true
        break
      }
    }
    return checked
  }

  function selectHeader(headerId, headerLabel) {
    const headerObj = { "id": headerId, "label": headerLabel }
    const currentSelected = selectedHeaders
    currentSelected.push(headerObj)
    setColumnsOpen(false)
    setSelectedHeaders(currentSelected)
  }

  function resetTableHeaders() {
    setSelectedHeaders([
      { id: 'id', label: 'ID' }, { id: 'order_number', label: 'Order Number' }, { id: 'ship_status', label: 'Shipment Status' },
      { id: 'cust_name', label: 'Customer Name' }, { id: 'shipping_method', label: 'Shipping Method' },
      { id: 'order_status', label: 'Order Status' }
    ])
    setColumnsOpen(false)
  }

  const formatDateAndTime = (inpDate) => {
    let retDate = ''
    const month = inpDate.toLocaleDateString('default', { month: 'short' })
    const date = inpDate.getDate()
    const year = inpDate.getFullYear()
    const formattedTime = inpDate.getHours() + ':' + inpDate.getMinutes() + ':' + inpDate.getSeconds()
    return retDate + month + '  ' + date + ',  ' + year + '  ' + formattedTime
  }

  React.useEffect(() => {
    axios.get(`${legolasApi.url}/admin/shipment/status`).then((res) => {
      // console.log(' Response: ', res)
      // setListData(res.data.data);
      const data = res.data.data.data, count = res.data.data.count
      setListData(data)
      setTotalcount(count)
      setSeletedStatus()
    }).catch((error) => console.log('Error in getting shipments for status: ', error))
  }, [])
 
  const pushValue =(id)=>{
    // console.log("action values",selectedCheck);
    setSeletedStatus(id)

  }
  const handleShipmentStatus =()=>{
    console.log("action values", selectedStatus);
    // setSeletedStatus(id)
    const submitPayload={
      requiredStatus:selectedStatus
    }
    let shipmentData = [] 
    selectedCheck.forEach((order)=>{
      const obj = {
        orderId:order.order_id,
        shipmentStatus:order.lookup_shipping_status
      }
      shipmentData.push(obj);
    })
    submitPayload['data']=shipmentData
    axios.post(`${legolasApi.url}/admin/updateshipment/status`,submitPayload).then((res) => {
        // console.log('Response: ', res)
        refreshPage();
      })
        .catch((err)=>{
        console.log("error",err);
        })
  }

  function refreshPage() {
    window.location.reload(false);
  }
 
  const handlePagination = (event, value) => {
    console.log('Pagination value: ', value)
    axios.get(`${legolasApi.url}/admin/shipment/status?offset=${value-1}`).then((res) => {
      console.log('nani res.data', res.data)
      const data = res.data.data.data, count = res.data.data.count
      setCurrentPage(value)
      setListData(data)
      setTotalcount(count)
    })
  }


 const pushChecked =(id,isChecked)=>{
  console.log("is checked",isChecked);
  if (!isChecked) {
    const current = [...selectedCheck]
    current.push(id);
    setSeletedCheck(current);
  } 
  if(isChecked){
    console.log("checked it",isChecked);
    const current = [...selectedCheck]
    const foundIndex = current.indexOf(id);
    current.splice(foundIndex,1);
    setSeletedCheck(current);

  }
   
 }

  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Shipments Status</Typography>
          </Box>
        </Box>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{
            width: '100%',
            display: 'flex',
            margin: '0px 30px',
            '& .MuiInput-input': {
              width: '300px !important',
              padding: '5px 10px !important'
            },
            '& .MuiSvgIcon-root': {
              paddingRight: '10px'
            }
          }}>
            <Input
              type='search'
              sx={{ border: '1px solid #2b3f7a', borderRadius: '20px' }}
              endAdornment={<SearchIcon sx={{ cursor: 'pointer' }} />}
              placeholder='Seach by keywords'
            //onChange={(e) => setSearchstring(e.target.value)}
            />
            <Select
              labelId="demo-select-small"
              id="demo-select-small"
              style={{ backgroundColor: 'transparent', backgroundRepeat: 'repeat', color: globalStyles.colors.black, width: 'auto', minWidth: '200px', borderRadius: '20px', border: '1px solid #2b3f7a', marginLeft: '20px' }}
              label={'Shipping Status'}
              sx={{
                '& .MuiSelect-select': {
                  margin: '0px 15px !important',
                  padding: '0px !important'
                },
                '& .MuiSelect-icon': {
                  position: 'relative',
                  right: 'unset !important',
                  top: 'unset !important'
                }
              }}
              onChange={(e)=>pushValue(e.target.value)}
            >
              <MenuItem value={1}>Customer Not Available</MenuItem>
              <MenuItem value={2}>Delivered</MenuItem>
             
              <MenuItem value={3}>In Transit</MenuItem>
              <MenuItem value={5}>Out for delivery</MenuItem>
              <MenuItem value={4}>Not Applicable</MenuItem>
              <MenuItem value={6}>Returned to shipper</MenuItem>
            </Select>
            <Box sx={{ 
              display: 'flex', justifyContent: 'flex-end', backgroundColor: globalStyles.colors.lightGrey,
              margin: '0 10px',
              '& .MuiButton-root': {
                backgroundColor: globalStyles.colors.backgroundPrimary,
                color: globalStyles.colors.white,
                borderRadius: '0px',
                textTransform: 'capitalize'
              }
            }}
            >
              <Button onClick={() => handleShipmentStatus()}>Action</Button>
            </Box>
            <Box sx={{
              width: '37vw',
              justifyContent: 'end',
              textAlign: 'end',
              '& .MuiButton-sizeSmall': {
                lineHeight: '30px !important'
              },
              '& .MuiDivider-root': {
                borderRightWidth: 'thin !important',
                borderColor: '#2b3f7a'
              }
            }}>
              <Button sx={globalStyles.listSubheaderIcons}>
                <FilterAltIcon /> Filters <Divider orientation="vertical" flexItem sx={{ padding: '0px 10px' }} />
              </Button>
              <Button sx={globalStyles.listSubheaderIcons} onClick={handleColumnClick}>
                <SettingsIcon /> Columns <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' } }} /> <Divider orientation="vertical" flexItem sx={{ '& .MuiDivider-root': { borderRightWidth: 'normal' } }} />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorCol}
                open={columnsOpen}
                onClose={() => setColumnsOpen(false)}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <FormControl>
                  <Box sx={{ margin: '10px 20px' }}>
                    <Typography>
                      {selectedHeaders.length} out of {allTableHeaders.length} visible
                    </Typography>
                  </Box>
                  <Box sx={{ width: '100%', borderTop: '1px solid #2b3f7a', borderBottom: '1px solid #2b3f7a', margin: '10px 20px', width: '92.5%' }}>
                    <FormGroup sx={{ display: 'grid', width: '100%', gridTemplateColumns: 'auto auto auto' }}>
                      {allTableHeaders.map((header) => {
                        if (header.id == 'id') {
                          return (
                            <FormControlLabel control={<Radio />} label={header.label} />
                          )
                        } else {
                          return (
                            <FormControlLabel control={
                              <Checkbox
                                checked={findChecked(header.id, selectedHeaders)} />}
                              label={header.label}
                              onChange={(e) => selectHeader(header.id, header.label)}
                            />
                          )
                        }
                      })}
                    </FormGroup>
                  </Box>
                  <Box sx={{
                    display: 'flex', margin: '10px 20px', justifyContent: 'space-between !important',
                    '& .MuiButton-root': {
                      textTransform: 'capitalize',
                      color: globalStyles.colors.backgroundPrimary
                    }
                  }}
                  >
                    <Button onClick={() => resetTableHeaders()}>Reset</Button>
                    <Button onClick={() => setColumnsOpen(false)}>Cancel</Button>
                  </Box>
                </FormControl>
              </Menu>
              <Button sx={globalStyles.listSubheaderIcons} onClick={handleClick}>
                <FileUploadIcon /> Export <ArrowDropDownIcon sx={{ '& .MuiSvgIcon-root': { paddingRight: '0px !important' } }} />
              </Button>
              <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                  'aria-labelledby': 'basic-button',
                }}
              >
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-radio-buttons-group-label"
                    defaultValue="female"
                    name="radio-buttons-group"
                  >
                    <FormControlLabel value="csv" control={<Radio size='small' />} label="CSV" />
                    <FormControlLabel value="excel" control={<Radio size='small' />} label="Excel XML" />
                  </RadioGroup>
                  <Box>
                    <Button onClick={() => setAnchorEl(null)}>Cancel</Button>
                    <Button>Export</Button>
                  </Box>
                </FormControl>
              </Menu>
            </Box>
          </Box>
        </Box>
        <Box sx={{
              display: 'flex',
              '& .MuiButton-sizeSmall': {
                lineHeight: '30px !important'
              },
              '& .MuiDivider-root': {
                borderRightWidth: 'thin !important',
                borderColor: '#2b3f7a'
              },
              margin: '0 30px'
            }}>
          <Box sx={{
              width: '25%',
              justifyContent: 'start',
              textAlign: 'start'
            }}>
            <Typography variant='subtitle1' sx={globalStyles.headerCountSubtitle}>
              Total {totalCount} record(s) found
            </Typography>
          </Box>
            
          <Box sx={{ 
            width: '75%',
            display: 'flex',
            padding: '10px 0 0 0',
            justifyContent: 'end',
            textAlign: 'end'
          }}>
            <Pagination count={Math.ceil(totalCount/50)} page={currentPage} onChange={handlePagination}/>
          </Box>
        </Box>
        <Box>
          <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
            <Table aria-label="simple table">
              <TableHead sx={{
                backgroundColor: globalStyles.colors.backgroundPrimary,
                height: '40px !important',
                borderRadius: '0 !important',
                '& .MuiTableCell-root': {
                  color: '#fff !important',
                  padding: '10px !important',
                  borderRight: '2px solid #fff !important',
                  borderRadius: '0 !important'
                }
              }}>
                {/* <input
                              type="checkbox"
                              className="form-check-input"
                              checked={!selectedCheck}
                              onChange={pushChecked}
                            /> */}
                {selectedHeaders.map((header) => [
                  <TableCell align='center'>{header.label}
                  </TableCell>

                ])}

              </TableHead>
              <TableBody>
                {listData.map((order) => {
                  return (
                    <StyledTableRow id={order.id}>
                      {selectedHeaders.map((header) => {
                        if (header.id === 'id') {
                          return (
                            <StyledTableCell align='center'><input
                              type="checkbox"
                              className="form-check-input"
                              checked={selectedCheck.includes(order)}
                              onChange={(e)=>pushChecked(order,selectedCheck.includes(order))}
                               // onChange={(e)=>{
                              //   console.log("target checl",e.target.checked);
                              //   console.log("selectedCheck.includes(order)",selectedCheck.includes(order));
                              // }}
                            /></StyledTableCell>
                            )
                          }
                          if (header.id === 'created_at') {
                            return (
                              <StyledTableCell align='center'>{formatDateAndTime(new Date(order[header.id]))}</StyledTableCell>
                            )
                          } else if (header.id == 'items') {
                            return (
                              <StyledTableCell align='center'>{order[header.id].length}</StyledTableCell>
                            )
                          } else if (header.id == 'lookup_shipping_status') {
                            return (
                              <StyledTableCell align='center'>{globalConfig.shipmentStatus[order[header.id]]}</StyledTableCell>
                            )
                          } else if (header.id == 'shipping_method') {
  
                            return (
                              <StyledTableCell align='center'>
                                {globalConfig.shipmentMethod[order[header.id]]}
                              </StyledTableCell>
                            )
                          } else if (header.id == 'payment_method') {
  
                            return (
                              <StyledTableCell align='center'>
                                {globalConfig.PaymentMethod[order[header.id]]}
                              </StyledTableCell>
                            )
                          } else {
                            return (
                              <StyledTableCell align='center'>
                                {order[header.id]}
                              </StyledTableCell>
                            )
                          }
                        })}
                        <StyledTableCell align='center'>
                        </StyledTableCell>
                      </StyledTableRow>
                    )
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Pagination count={Math.ceil(totalCount/50)} page={currentPage} onChange={handlePagination}/>
      </List>
    </React.Fragment>
  )
}

export default ShipmentStatusList

